import {
  faClipboardCheck,
  faBoxOpen,
  faMapMarkerAlt,
  faCalendarAlt,
  faFileAlt,
  faUser,
  faFolder,
  faMap,
} from '@fortawesome/free-solid-svg-icons'
import createField from '../../utils/factory/createField'
import { faSwift } from '@fortawesome/free-brands-svg-icons'

export const destinationFields = [
  {
    section: 'Destino da requisição',
    description:
      'O destino da requisição é por exemplo: "UBS Jardim Iracema", "Escola Municipal José de Anchieta", etc.',
    fields: [
      createField({
        id: 'destination_orders.name',
        label: 'Nome do Destino',
        type: 'text',
        placeholder: 'Informe o nome do destino',
        fullWidth: true,
      }),
    ],
  },
]

export const detailsOrderServiceGlobalFields = [
  {
    section: 'Informações',
    fields: [
      createField({
        id: 'id',
        label: 'Nº Requisição',
        type: 'text',
        icon: faClipboardCheck,
        disabled: true,
      }),
      createField({
        id: 'movement_type',
        label: 'Tipo Movimento',
        type: 'text',
        icon: faClipboardCheck,
        disabled: true,
      }),
      createField({
        id: 'contract',
        label: 'Nº Contrato',
        type: 'text',
        icon: faClipboardCheck,
        disabled: true,
      }),
      createField({
        id: 'recipient_customer',
        label: 'Cliente Destinatário',
        type: 'text',
        icon: faUser,
        disabled: true,
      }),
      createField({
        id: 'destination_order',
        label: 'Destino',
        type: 'text',
        icon: faMap,
        disabled: true,
      }),
      createField({
        id: 'mode_transport',
        label: 'Meio',
        type: 'text',
        icon: faMapMarkerAlt,
        disabled: true,
      }),
      createField({
        id: 'user',
        label: 'Criado Por',
        type: 'text',
        icon: faClipboardCheck,
        fullWidth: true,
        disabled: true,
      }),
      createField({
        id: 'changed_by',
        label: 'Responsável pela decisão',
        type: 'text',
        icon: faClipboardCheck,
        disabled: true,
      }),
      createField({
        id: 'situation',
        label: 'Situação',
        type: 'text',
        icon: faClipboardCheck,
        disabled: true,
      }),
      createField({
        id: 'deadline',
        label: 'Prazo Final',
        type: 'text',
        icon: faCalendarAlt,
        disabled: true,
      }),
      createField({
        id: 'created_at',
        label: 'Criado Em',
        type: 'text',
        icon: faCalendarAlt,
        disabled: true,
      }),
      createField({
        id: 'details',
        label: 'Detalhes',
        type: 'textarea',
        fullWidth: true,
        icon: faFileAlt,
        disabled: true,
      }),
    ],
  },
]

export const baseOsDynamicFields = [
  {
    section: 'Requisição',
    fields: [
      createField({
        id: 'order.movement_type_id',
        label: 'Tipo Movimento',
        type: 'select',
        placeholder: 'Selecione o tipo de movimento',
        icon: faClipboardCheck,
        isClearable: true,
      }),
      createField({
        id: 'order.contract_id',
        label: 'Contrato',
        type: 'select',
        placeholder: 'Selecione o contrato',
        icon: faFolder,
        isClearable: true,
      }),
      createField({
        id: 'order.recipient_customer_id',
        label: 'Cliente Destinatário',
        type: 'select',
        placeholder: 'Selecione o cliente',
        icon: faUser,
        isClearable: true,
      }),
      createField({
        id: 'order.address_id',
        label: 'Endereço',
        type: 'select',
        placeholder: 'Selecione o endereço',
        icon: faMapMarkerAlt,
        isClearable: true,
      }),
      createField({
        id: 'order.location_id',
        label: 'Localização',
        type: 'select',
        placeholder: 'Selecione a localização',
        icon: faMapMarkerAlt,
        notRequired: true,
        isClearable: true,
      }),
      createField({
        id: 'order.mode_transport_id',
        label: 'Meio',
        type: 'select',
        placeholder: 'Selecione o destino',
        icon: faMapMarkerAlt,
        isClearable: true,
      }),
      // 🆕 NOVO CAMPO - Necessita de Nota Fiscal
      createField({
        id: 'order.requires_invoice',
        label: 'Necessita de Nota Fiscal?',
        type: 'select',
        placeholder: 'Selecione',
        icon: faFileAlt,
        notRequired: true,
        options: [
          { value: false, label: 'Não' },
          { value: true,  label: 'Sim' },
        ],
      }),
      createField({
        id: 'order.deadline',
        label: 'Prazo Final',
        type: 'date',
        placeholder: 'Selecione a data do prazo final',
        icon: faCalendarAlt,
      }),
      createField({
        id: 'order.details',
        label: 'Detalhes',
        type: 'textarea',
        placeholder: 'Digite o detalhes',
        fullWidth: true,
        icon: faFileAlt,
        required: true,
      }),
    ],
  },
  {
    section: 'Equipamentos',
    array: true,
    fields: [
      // TODO: ALUGUEL
      createField({
        id: 'equipments.contract_item_id',
        label: 'Item Contrato',
        type: 'select',
        placeholder: 'Selecione o item do contrato',
        icon: faBoxOpen,
        fullWidth: true,
      }),
      createField({
        id: 'equipments.type_id',
        label: 'Tipo do equipamento',
        type: 'select',
        placeholder: 'Selecione o tipo do equipamento',
        icon: faBoxOpen,
        fullWidth: true,
      }),
      createField({
        id: 'equipments.quantity',
        label: 'Quantidade',
        type: 'number',
        placeholder: 'Digite a Quantidade',
        icon: faBoxOpen,
      }),
      createField({
        id: 'equipments.equipment_id', // TODO: SUBSTITUIÇÃO / DEVOLUÇÃO
        label: 'Equipamento',
        type: 'select',
        placeholder: 'Selecione o equipamento',
        icon: faBoxOpen,
        fullWidth: true,
        isMulti: false,
      }),
      createField({
        id: 'equipments.department_id',
        label: 'Departamento',
        type: 'select',
        placeholder: 'Selecione o departamento',
        icon: faClipboardCheck,
      }),
      createField({
        id: 'equipments.details', // TODO: ALUGUEL / SUBSTITUIÇÃO / DEVOLUÇÃO
        label: 'Detalhes',
        type: 'textarea',
        placeholder: 'Digite os detalhes',
        fullWidth: true,
        icon: faFileAlt,
        notRequired: true,
      }),
    ],
  },
  {
    section: 'Insumos',
    array: true,
    fields: [
      createField({
        id: 'items.product_id',
        label: 'Insumo',
        type: 'select',
        placeholder: 'Selecione o insumo',
        icon: faBoxOpen,
        isMulti: false,
        fullWidth: true,
      }),
      createField({
        id: 'items.quantity_product',
        label: 'Quantidade',
        type: 'number',
        placeholder: 'Digite a Quantidade',
        icon: faBoxOpen,
      }),
      createField({
        id: 'items.department_id',
        label: 'Departamento',
        type: 'select',
        placeholder: 'Selecione o departamento',
        icon: faClipboardCheck,
      }),
      createField({
        id: 'items.details',
        label: 'Detalhes',
        type: 'textarea',
        placeholder: 'Digite os detalhes',
        fullWidth: true,
        icon: faFileAlt,
        notRequired: true,
      }),
    ],
  },
  {
    section: 'Kit de Equipamentos',
    array: true,
    fields: [
      createField({
        id: 'extras.equipment_id',
        label: 'Item de Referência',
        type: 'select',
        placeholder: 'Selecione um item da lista de equipamentos',
        icon: faBoxOpen,
        isClearable: true,
      }),
      createField({
        id: 'extras.type_id',
        label: 'Tipo de Equipamento',
        type: 'select',
        placeholder: 'Selecione o tipo de equipamento',
        icon: faBoxOpen,
        isClearable: true,
      }),
      createField({
        id: 'extras.quantity',
        label: 'Quantidade',
        type: 'number',
        placeholder: 'Digite a Quantidade',
        icon: faBoxOpen,
        fullWidth: true,
      }),
    ],
  },
]

export const baseOsAddItemsFields = [
  {
    section: 'Requisição',
    fields: [
      createField({
        id: 'order.id',
        label: 'Nº Requisição',
        type: 'select',
        placeholder: 'Selecione o tipo de movimento',
        icon: faClipboardCheck,
      }),
      createField({
        id: 'order.movement_type_id',
        label: 'Tipo Movimento',
        type: 'select',
        placeholder: 'Selecione o tipo de movimento',
        icon: faClipboardCheck,
      }),
      createField({
        id: 'order.contract_id',
        label: 'Contrato',
        type: 'select',
        placeholder: 'Selecione o contrato',
        icon: faFolder,
        fullWidth: true,
      }),
      createField({
        id: 'order.recipient_customer_id',
        label: 'Cliente Destinatário',
        type: 'select',
        placeholder: 'Selecione o cliente',
        icon: faUser,
      }),
      createField({
        id: 'order.address_id',
        label: 'Endereço',
        type: 'select',
        placeholder: 'Selecione o endereço',
        icon: faMapMarkerAlt,
        isClearable: true,
      }),
      createField({
        id: 'order.location_id',
        label: 'Localização',
        type: 'select',
        placeholder: 'Selecione a localização',
        icon: faMapMarkerAlt,
        notRequired: true,
        isClearable: true,
      }),
      createField({
        id: 'order.mode_transport_id',
        label: 'Meio',
        type: 'select',
        placeholder: 'Selecione o destino',
        icon: faMapMarkerAlt,
      }),
      createField({
        id: 'order.deadline',
        label: 'Prazo Final',
        type: 'date',
        placeholder: 'Selecione a data do prazo final',
        icon: faCalendarAlt,
      }),
    ],
  },
  {
    section: 'Equipamentos',
    array: true,
    fields: [
      // TODO: ALUGUEL
      createField({
        id: 'equipments.contract_item_id',
        label: 'Item Contrato',
        type: 'select',
        placeholder: 'Selecione o item do contrato',
        icon: faBoxOpen,
        fullWidth: true,
      }),
      createField({
        id: 'equipments.type_id',
        label: 'Tipo do equipamento',
        type: 'select',
        placeholder: 'Selecione o tipo do equipamento',
        icon: faBoxOpen,
        fullWidth: true,
      }),
      createField({
        id: 'equipments.quantity',
        label: 'Quantidade',
        type: 'number',
        placeholder: 'Digite a Quantidade',
        icon: faBoxOpen,
      }),
      createField({
        id: 'equipments.equipment_id', // TODO: SUBSTITUIÇÃO / DEVOLUÇÃO
        label: 'Equipamento',
        type: 'select',
        placeholder: 'Selecione o equipamento',
        icon: faBoxOpen,
        fullWidth: true,
        isMulti: false,
      }),
      createField({
        id: 'equipments.department_id',
        label: 'Departamento',
        type: 'select',
        placeholder: 'Selecione o departamento',
        icon: faClipboardCheck,
      }),
      createField({
        id: 'equipments.details', // TODO: ALUGUEL / SUBSTITUIÇÃO / DEVOLUÇÃO
        label: 'Detalhes',
        type: 'textarea',
        placeholder: 'Digite os detalhes',
        fullWidth: true,
        icon: faFileAlt,
        notRequired: true,
      }),
    ],
  },
  {
    section: 'Insumos',
    array: true,
    fields: [
      createField({
        id: 'items.product_id',
        label: 'Insumo',
        type: 'select',
        placeholder: 'Selecione o insumo',
        icon: faBoxOpen,
        isMulti: false,
        fullWidth: true,
      }),
      createField({
        id: 'items.quantity_product',
        label: 'Quantidade',
        type: 'number',
        placeholder: 'Digite a Quantidade',
        icon: faBoxOpen,
      }),
      createField({
        id: 'items.department_id',
        label: 'Departamento',
        type: 'select',
        placeholder: 'Selecione o departamento',
        icon: faClipboardCheck,
      }),
      createField({
        id: 'items.details',
        label: 'Detalhes',
        type: 'textarea',
        placeholder: 'Digite os detalhes',
        fullWidth: true,
        icon: faFileAlt,
        notRequired: true,
      }),
    ],
  },
  {
    section: 'Kit de Equipamentos',
    array: true,
    fields: [
      createField({
        id: 'extras.equipment_id',
        label: 'Item de Referência',
        type: 'select',
        placeholder: 'Selecione um item da lista de equipamentos',
        icon: faBoxOpen,
        isClearable: true,
      }),
      createField({
        id: 'extras.type_id',
        label: 'Tipo de Equipamento',
        type: 'select',
        placeholder: 'Selecione o tipo de equipamento',
        icon: faBoxOpen,
        isClearable: true,
      }),
      createField({
        id: 'extras.quantity',
        label: 'Quantidade',
        type: 'number',
        placeholder: 'Ex: 1',
        icon: faBoxOpen,
        fullWidth: true,
        isClearable: true,
      }),
    ],
  },
]

export const baseEditOsFields = [
  {
    section: 'Informações',
    fields: [
      createField({
        id: 'order.id',
        label: 'Nº Requisição',
        type: 'select',
        placeholder: 'Selecione o tipo de movimento',
        icon: faClipboardCheck,
      }),
      createField({
        id: 'order.movement_type_id',
        label: 'Tipo Movimento',
        type: 'select',
        placeholder: 'Selecione o tipo de movimento',
        icon: faClipboardCheck,
      }),
      createField({
        id: 'order.contract_id',
        label: 'Contrato',
        type: 'select',
        placeholder: 'Selecione o contrato',
        icon: faFolder,
        fullWidth: true,
      }),
      createField({
        id: 'order.recipient_customer_id',
        label: 'Cliente Destinatário',
        type: 'select',
        placeholder: 'Selecione o cliente',
        icon: faUser,
        fullWidth: true,
      }),
      createField({
        id: 'order.mode_transport_id',
        label: 'Meio',
        type: 'select',
        placeholder: 'Selecione o destino',
        icon: faMapMarkerAlt,
      }),
      // 🆕 NOVO CAMPO - Necessita de Nota Fiscal
      createField({
        id: 'order.requires_invoice',
        label: 'Necessita de Nota Fiscal?',
        type: 'select',
        placeholder: 'Selecione',
        icon: faFileAlt,
        notRequired: true,
        options: [
          { value: false, label: 'Não' },
          { value: true,  label: 'Sim' },
        ],
      }),
      createField({
        id: 'order.deadline',
        label: 'Prazo Final',
        type: 'date',
        placeholder: 'Selecione a data do prazo final',
        icon: faCalendarAlt,
      }),
      createField({
        id: 'order.details',
        label: 'Detalhes',
        type: 'textarea',
        placeholder: 'Digite o detalhes',
        fullWidth: true,
        icon: faFileAlt,
      }),
    ],
  },
]

export const baseOsEditItemsFields = [
  {
    section: 'Kit de Equipamentos',
    array: true,
    fields: [
      createField({
        id: 'extras.type_id',
        label: 'Tipo de Equipamento',
        type: 'select',
        placeholder: 'Selecione o tipo de equipamento',
        icon: faBoxOpen,
        isClearable: true,
      }),
      createField({
        id: 'extras.quantity',
        label: 'Quantidade',
        type: 'number',
        placeholder: 'Ex: 1',
        icon: faBoxOpen,
        isClearable: true,
      }),
    ],
  },
]

export const attachContractFields = [
  {
    section: 'Requisição',
    fields: [
      createField({
        id: 'order.recipient_customer_id',
        label: 'Cliente Destinatário',
        type: 'select',
        placeholder: 'Selecione o cliente',
        icon: faUser,
        disabled: true,
        isClearable: true,
      }),
      createField({
        id: 'order.contract_id',
        label: 'Contrato',
        type: 'select',
        placeholder: 'Selecione o contrato',
        icon: faFolder,
        isClearable: true,
      }),
      createField({
        id: 'order.mode_transport_id',
        label: 'Meio',
        type: 'select',
        placeholder: 'Selecione o destino',
        icon: faMapMarkerAlt,
        isClearable: true,
        disabled: true,
      }),
      createField({
        id: 'order.deadline',
        label: 'Prazo Final',
        type: 'date',
        placeholder: 'Selecione a data do prazo final',
        fullWidth: true,
        icon: faCalendarAlt,
        disabled: true,
      }),
      createField({
        id: 'order.details',
        label: 'Detalhes',
        type: 'textarea',
        placeholder: 'Digite o detalhes',
        fullWidth: true,
        icon: faFileAlt,
      }),
    ],
  },
  {
    section: 'Equipamentos',
    array: true,
    fields: [
      createField({
        id: 'equipments.type_item_id',
        label: 'Tipo do Item?',
        type: 'select',
        placeholder: 'Selecione a opção',
        isClearable: true,
        icon: faSwift,
      }),
      // TODO: ALUGUEL
      createField({
        id: 'equipments.contract_item_id',
        label: 'Item Contrato',
        type: 'select',
        placeholder: 'Selecione o item do contrato',
        icon: faBoxOpen,
        disabled: true,
      }),
      createField({
        id: 'equipments.type_id',
        label: 'Tipo do equipamento',
        type: 'select',
        placeholder: 'Selecione o tipo do equipamento',
        icon: faBoxOpen,
        disabled: true,
      }),
      createField({
        id: 'equipments.quantity',
        label: 'Quantidade',
        type: 'number',
        placeholder: 'Digite a Quantidade',
        icon: faBoxOpen,
        disabled: true,
      }),
    ],
  },
]
